var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"width":"100%"}},[_c('v-card-text',{attrs:{"width":"100%"}},[_c('QuokkaEventRecordingAdmin',{attrs:{"event-recording-admin-display-type":"ads-event-recording"},on:{"event-select":_vm.onEventSelect}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }